import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-register',
    templateUrl: './user-register.component.html',
    styleUrls: ['./user-register.component.scss'],
    standalone: false
})
export class UserRegisterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
